import { TripContainer } from "./tripContainer";

export class TripPayment{
    id: number;
    tripId: number;
    paymentType: string;
    dateRecieved: string;
    remarks: string;
    amount: number;
    checkDueDate: string;
    verifiedBy: number;
    isDeposited: boolean;

    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;

    //extra fields for viewing purposes only
    billOfLading?: string;
    clientId?: number;
    clientName?: string;
    verifier?: string;
    shippingLine?: string;
    tripDate?: string;
    containerQuantity: number;
    firstContainerDetail?: TripContainer;

    amountPaid: number = 0;
    tripRate: number = 0;
    remainingBalance: number = 0;
}


// WEBPACK FOOTER //
// ./src/app/models/trips/trip.payment.ts